import React from 'react'
import { Box } from 'components/atoms/Layout'

const commonProps = {
  width: '100%',
  mx: 'auto',
  px: 'm',
}

const Container = React.forwardRef((props, ref) => (
  <Box {...props} {...commonProps} maxWidth={1200} ref={ref} />
))

const Narrow = React.forwardRef((props, ref) => (
  <Box {...props} {...commonProps} maxWidth={700} ref={ref} />
))

Container.Narrow = Narrow

const FullWidth = React.forwardRef((props, ref) => (
  <Box {...props} {...commonProps} ref={ref} />
))

Container.FullWidth = FullWidth

export default Container
